import React from "react";
import WvContactUsForm from "~/components/organisms/WvContactUsForm";
import type { ContactUsFormSliceDefault } from "~/lib/prismic/types.generated";
import { asLink, asText } from "@prismicio/helpers";
import type { HTMLComponent } from "../../../../../../../../libs/react/src/lib/types";
import { linkResolver } from "~/lib/prismic/utils";

const ContactUsFormHalfPage: HTMLComponent<{
  slice: ContactUsFormSliceDefault;
}> = ({ slice }) => {
  return (
    <div className="component__contact">
      <div className="container">
        <div className="row">
          <div className="col-12 col-lg-6">
            <WvContactUsForm
              title={asText(slice.primary.title)}
              linkToAfterSubmit={
                asLink(slice.primary.linktoaftersubmit, linkResolver) || ""
              }
              captchaSiteKey={asText(slice.primary.captcha_site_key)}
            />
          </div>
          <div className="col-12 col-lg-6 px-lg-4 px-xl-5">
            <div className="d-flex flex-column  justify-content-center content h-100"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUsFormHalfPage;
